/* eslint-disable */
export default {
  Home: 'Thuis',
  Mobile: 'Mobiel',
  Work: 'Werk',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
